/**
 * StepWelcome — full-bleed split welcome screen (step 0).
 *
 * Left panel: rendered by OnboardingShell with typewriter headline.
 * Right panel: welcome message + Get Started button.
 * No name/email form — identity comes from SSO (Google).
 */
import OnboardingShell from './OnboardingShell';

interface StepWelcomeProps {
  managerName: string;
  onNext: () => void;
}

export default function StepWelcome({ managerName, onNext }: StepWelcomeProps) {
  const firstName = managerName.split(' ')[0] || managerName;

  return (
    <OnboardingShell leftTitle="I'm your Performance Review Assistant. Let's create your manager reviews together.">
      <h2 style={{
        fontSize: 26, fontWeight: 800, color: '#0f0f0f',
        marginBottom: 10, letterSpacing: '-0.02em',
      }}>
        Welcome{firstName ? `, ${firstName}` : ''}! 👋
      </h2>

      <p style={{ fontSize: 14, color: '#666', lineHeight: 1.65, marginBottom: 36 }}>
        I'll guide you through a structured review of each of your direct reports,
        fully aligned with FINN's Talent Framework and Calibration Rules.
        By the end, you'll have a complete manager review ready to paste directly into Culture Amp.
      </p>

      <button
        onClick={onNext}
        style={{
          width: '100%', padding: '15px 24px',
          background: '#0087eb', color: '#fff',
          border: 'none', borderRadius: 8,
          fontSize: 15, fontWeight: 700,
          fontFamily: 'Inter, sans-serif', cursor: 'pointer',
          letterSpacing: '0.01em',
        }}
        onMouseEnter={e => { e.currentTarget.style.background = '#006fca'; }}
        onMouseLeave={e => { e.currentTarget.style.background = '#0087eb'; }}
      >
        Get Started →
      </button>
    </OnboardingShell>
  );
}
